import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Spinner } from '@servicetitan/design-system/dist/components/Spinner/Spinner';
import { Stack } from '@servicetitan/design-system/dist/components/Stack/Stack';
import { SpinnerStyles } from './spinner-styles';
export const CenteredSpinner = ({ size, className, color }) => {
    return (_jsxs(Stack, Object.assign({ className: classNames(className, 'h-100 w-100'), justifyContent: "center", alignItems: "center" }, { children: [color && _jsx(SpinnerStyles, { inputClassName: "action-spinner", color: color }, void 0), _jsx(Spinner, { className: "of-hidden action-spinner", size: size }, void 0)] }), void 0));
};
//# sourceMappingURL=centered-spinner.js.map